import { JSONContent } from '@provision/rich-text-editor';
import { MacroActionRule } from 'src/graphql';

export type MacroWithValid = MacroActionRule & { isValid: boolean; id?: string };

export interface EditorDoc extends JSONContent {
  meta?: { macros?: MacroWithValid[] };
}

export function readMacrosFromDoc(doc?: EditorDoc | null): MacroWithValid[] {
  if (!doc) {
    return [];
  }
  const meta = ensureMeta(doc);
  return toArray<MacroWithValid>(meta.macros);
}

export function writeMacrosToDoc(doc: EditorDoc, macros: MacroWithValid[]): EditorDoc {
  if (!doc) {
    return doc;
  }

  const meta = doc.meta ? { ...doc.meta } : {};

  return {
    ...doc,
    meta: { ...meta, macros },
  };
}

export function removeMacroAt(doc: EditorDoc, index: number): EditorDoc {
  const list = readMacrosFromDoc(doc);
  const next = list.filter((_, i) => i !== index);
  return writeMacrosToDoc(doc, next);
}

type EditorMeta = NonNullable<EditorDoc['meta']>;

function ensureMeta(doc: EditorDoc): EditorMeta {
  if (doc.meta && typeof doc.meta === 'object') {
    return doc.meta;
  }

  const meta: EditorMeta = {};
  doc.meta = meta;
  return meta;
}

function toArray<T>(value: unknown): T[] {
  return Array.isArray(value) ? (value as T[]) : [];
}
